import { Suspense, lazy } from 'react';
import { Outlet } from 'react-router-dom';
const Fab = lazy(() => import('./../components/shared/FAB'));

function AuthLayout() {
  return (
    <>
      <Outlet />
      <Suspense>
        <Fab />
      </Suspense>
    </>
  );
}

export default AuthLayout;
